import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownAndRightDottedSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m20.71 4.71-2 2 .03-.01c-.2.19-.45.29-.71.29s-.51-.09-.71-.29a.996.996 0 0 1 0-1.41l.29-.29H5.02v12.58l.29-.29a.996.996 0 1 1 1.41 1.41l-2 2c-.1.1-.21.17-.33.22s-.25.08-.38.08-.26-.03-.38-.08a1 1 0 0 1-.33-.22l-2-2a.996.996 0 1 1 1.41-1.41l.29.29V3.99c0-.55.45-1 1-1h13.59l-.29-.29a.996.996 0 1 1 1.41-1.41l2 2a1.004 1.004 0 0 1 0 1.42M19 19c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1s.45-1 1-1m1-6c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55-.45-1-1-1m-1-4c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1s-1-.45-1-1zm-4 10h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1m-6 0h1c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowDownAndRightDottedSquare;
